import TopicBanner from '../../Components/topicBanner/TopicBanner';
import bnrInnerImg from '../../assets/images/png/topicbanner-img1.png';
import bnrImg from '../../assets/images/png/topicbnr1.png';
import Layouts from '../../layouts/Layouts';
import { TopicsFilter } from '../../Components/Forms';
import PopularTopics from './popularTopics/PopularTopics';
import './sehatAtoZ.css';

function SehatAtoZ() {
  return (
    <Layouts>
      <section className="sehatAtoZ">
        <TopicBanner
          bgImg={bnrImg}
          img={bnrInnerImg}
          title="Sehat A to Z"
          desc="Become your best self. Discover new ways to live an inspiring life through natural beauty, nutrition and diet, an active lifestyle, and better relationships."
        />
        <PopularTopics />
        <TopicsFilter />
      </section>
    </Layouts>
  );
}

export default SehatAtoZ;
